const useGetProvider = () => {
    return async (providerID, feedbackKey = null) => {
        let response;

        try {
            const query = feedbackKey ? `?feedback_key=${encodeURIComponent(feedbackKey)}` : '';

            response = await fetch(
                `${process.env.REACT_APP_API_URL}/provider/${providerID}/${query}`,
                {
                    method: 'GET',
                    headers: {
                        'Access-Control-Request-Method': 'GET'
                    }
                }
            );
        } catch (error) {
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: ` - ${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 200) {
            const error = new Error();
            error.status = response.status;
            switch (response.status) {
                case 400:
                case 415:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.client-bad-request',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    break;
                default:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.api-bad-response',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useGetProvider;
